<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="modalController.dismiss()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end" *ngIf="document && document.documentType !== 2 && document.documentType !== 3">
            <ion-button (click)="openModalAddCustomer()">
                <ion-icon slot="icon-only" name="add"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-searchbar animated debounce="300" [(ngModel)]="queryText"></ion-searchbar>
    </ion-toolbar>
</ion-header>
<ion-content>
    <ion-refresher slot="fixed" (ionRefresh)="fetchCustomers($event)">
        <ion-refresher-content
                pullingIcon="arrow-dropdown"
                pullingText="Pull to refresh"
                refreshingSpinner="circles"
                refreshingText="Updating Customers...">
        </ion-refresher-content>
    </ion-refresher>
    <ion-virtual-scroll [items]="customerList | filter: queryText">
        <ion-item *virtualItem="let cust" (click)="selectCustomer(cust)">
            <ion-label [color]="cust.suspended === 'Y' ? 'danger' : 'dark'">
                <h4><strong> {{ cust.name }} </strong></h4>
                <p style="color: #1aacc3"> Location : {{ getDepotName(cust.location) }} </p>
                <p> {{ cust.cod }} </p>
                <p> {{ cust.add1 }} </p>
                <p> {{ cust.add2 }} </p>
                <p> {{ cust.add3 }} </p>
                <p> {{ cust.add4 }} </p>
            </ion-label>
        </ion-item>
    </ion-virtual-scroll>
</ion-content>
